<template>

  <div id="detailCanvas" ref="detailCanvas" class="detailContent canvas-box">
    <div class="title">
      <div class="title-name">{{ $t('data.payout_details') }}</div>
      <!-- <img height="25" src="@/assets/logo/logo.svg"> -->
    </div>
    <div class="detail-card">
      <template v-if="merchantInfo.transaction_type === TRANSACTION_TYPE_FX">
        <div class="info-amount-txt">{{$t('data.destination_amount')}}:</div>
        <div class="info-amount">{{  merchantInfo.destination_currency}}  {{ merchantInfo.destination_amount | toDivideWithDot }}</div>
        <div class="info-amount-txt">{{$t('data.source_amount')}}:</div>
        <div class="info-amount">{{  merchantInfo.source_currency}}  {{ merchantInfo.source_amount | toDivideWithDot }}</div>
        <div class="info-amount-txt">{{ $t('data.fee') }}::</div>
        <div class="info-amount">{{ merchantInfo.mch_foreign_exchange_fee_resp.fee_split_currency}}  {{  merchantInfo.mch_foreign_exchange_fee_resp.fee_split | toDivideWithDot }}</div>
      </template>
      <template v-else>
        <div class="info-amount-txt">{{ $t('data.destination_amount') }}:</div>
        <div class="info-amount">{{ showDestinationCurrency }}  {{ merchantInfo.po_trans_amount | toDivideWithDot }}</div>
        <div class="info-amount-txt">{{ $t('data.fee') }}:</div>
        <div class="info-amount">{{ showFeeCurrency }}  {{ merchantInfo.fee_split | toDivideWithDot }}</div>
      </template>
      <div class="line" style="marginTop: 10px;marginBottom: 9px" />

      <div class="modalRow flex" style="height: 39px;">
        <div class="modalCol col-min-width">{{ $t('merchantAccount.transaction_id') }}：</div>
        <div class="modalCol moreBlock">{{ merchantInfo.transaction_id }}</div>
      </div>
      <div class="modalRow flex">
        <div class="modalCol">{{ $t('merchantAccount.create_time') }}：</div>
        <div class="modalCol moreBlock">{{ merchantInfo.transaction_create_time }}</div>
      </div>
      <div class="modalRow flex">
        <div class="modalCol col-min-width">{{ $t('merchantAccount.complete_time') }}：</div>
        <div class="modalCol moreBlock">{{ merchantInfo.transaction_return_time }}</div>
      </div>

      <div class="modalRow flex">
        <div class="modalCol col-min-width">{{ $t('customerService.remitting_bank') }}：</div>
        <div class="modalCol moreBlock">{{ merchantInfo.sender_bank_name }}</div>
      </div>

      <div class="modalRow flex">
        <div class="modalCol col-min-width">{{ $t('customerService.remittance_account') }}：</div>
        <div class="modalCol moreBlock">{{ merchantInfo.sender_bank_account |strAesDecryptAndAsterisk }}</div>
      </div>

      <div class="modalRow flex">
        <div class="modalCol col-min-width">{{ $t('merchantAccount.recipient_name') }}：</div>
        <div class="modalCol moreBlock">{{ merchantInfo.recipient_name | strAesDecryptAndAsterisk }}</div>
      </div>
      <div class="modalRow flex">
        <div class="modalCol col-min-width">{{ $t('merchantAccount.recipient_mobile') }}：</div>
        <div class="modalCol moreBlock">{{ merchantInfo.recipient_mobile }}</div>
      </div>
      <div class="modalRow flex">
        <div class="modalCol col-min-width">{{ $t('merchantAccount.recipient_channel') }}：</div>
        <div class="modalCol moreBlock">{{ merchantInfo.recipient_channel }}</div>
      </div>
      <div class="modalRow flex">
        <div class="modalCol col-min-width">{{ $t('merchantAccount.recipient_account') }}：</div>
        <div class="modalCol moreBlock">{{ merchantInfo.recipient_account | strAesDecryptAndAsterisk }}</div>
      </div>
      <div class="modalRow flex">
        <div class="modalCol col-min-width">{{ $t('data.remark') }}：</div>
        <div class="modalCol moreBlock">{{ merchantInfo.product_name }}</div>
      </div>
      <div class="line" style="marginBottom: 10px; marginTop: 5px" />
      <div class="download-time">{{ $t('data.download_time') }}: {{ Date.now() | parseTime() }}</div>
    </div>

    <el-tag :type="getPOTransactionStatusType(merchantInfo.po_trans_status)" class="modalBtn"> {{ getPOTransactionStatusMap(merchantInfo.po_trans_status) }}</el-tag>
  </div>

</template>

<script>
import html2canvas from 'html2canvas'
import { poTransStatusMap } from '@/utils/maps'
export default {
  name: 'PayoutDetailDownload',
  props: {
    merchantInfo: {
      type: Object,
      default: function() {
        return {
          merchant: {
            merchant_basic_info: {}
          },
          disbursement_fee: {
          }
        }
      }
    }
  },
  data(){
    this.TRANSACTION_TYPE_FX = 4
    return {

    }
  },
  computed: {
    showDestinationCurrency() {
      return this.$store.getters.isAllCountry ? this.merchantInfo.destination_currency : this.$store.getters.currency
    },
    showFeeCurrency() {
      return this.$store.getters.isAllCountry
        ? this.merchantInfo.fee_split_currency
        : this.$store.getters.currency
    },
    getPOTransactionStatusType() {
      return function(value) {
        return poTransStatusMap(value).type
      }
    },
    getPOTransactionStatusMap() {
      return function(value) {
        return poTransStatusMap(value).label
      }
    }
  },
  methods: {
    saveImg() {
      const val = 'detailCanvas'
      window.pageYoffset = 0
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
      const node = document.getElementById(val)

      const width = node.offsetWidth
      const height = node.offsetHeight
      const scale = 2
      html2canvas(node, {
        width: width,
        heigth: height,
        backgroundColor: '#ffffff',
        dpi: window.devicePixelRatio * 2,
        scale: scale,
        X: 0,
        Y: 0,
        scrollX: -3,
        scrollY: 0,
        useCORS: true,
        allowTaint: true
      }).then(canvas => {
        const url = canvas.toDataURL()
        const a = document.createElement('a')
        a.download = 'Payout_' + (new Date()).getTime()
        const event = new MouseEvent('click')
        a.href = url
        a.dispatchEvent(event)
      })
    },
    onClickCancel() {
      this.changModalStatus(false)
    }
  }
}
</script>
<style scoped lang="scss">
.title{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 31px 10px 25px;
  .title-name{
    font-size: 17px;
    font-weight: 500;  font-family: 'Inter-Medium';
    color: #1D3A71;
  }
}
.canvas-box{
  position: absolute;
  top: -300vh;
  background: #FFFFFF;
  // display: none;
}
.detail-card{
  margin: 0 17px 10px;
  padding: 7px 10px 10px;
  // box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.16);
  border: 1px solid #EAEAF2;
  border-radius: 10px 10px 0px 0px;
  .info-amount-txt{
    margin-top: 10px;
    font-size: 13px;
    font-weight: 400;
    color: #7E7E7E;
    line-height: 18px;
  }
  .info-amount{
    margin-top: 3px;
    font-size: 15px;
    font-weight: bold;
    color: #333333;
    line-height: 21px;
  }
  .line{
    border-top: 1px solid #EAEAF2;
  }
}
.detailContent{
  width: 375px;
  .flex{
    display: flex;
  }
  .modalRow{
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 34px;
  }
  .modalCol{
    flex-basis: 50%;
    font-size: 13px;
    font-weight: 400;
    color: #888888;
    line-height: 1.5;
  }
  .col-min-width{
    min-width: 130px;
  }
  .moreBlock{
    line-height: 1.5;
    color: #333333;
  }
  .modalBtn{
    line-height: 25px;
    display: inline-block;
    position: absolute;
    top: 74px;
    right: 27px;
  }
  .download-time{
    text-align: center;
    font-size: 13px;
    font-weight: 400;
    color: #B9B9B9;
    line-height: 1.5;
  }
}

</style>
